module.exports = __webpack_public_path__ + "img/icon-settings.c24c941a.svg";